/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = asciiToArray;
